<template>
    <div data-cy="container_landing_main"></div>
</template>
<script>
import BzbsAuth from "@/core/Account/service/BzbsAuth.js";
import BzbsProfile from "@/core/Account/service/BzbsProfile.js";
import Locale from "@/helper/locale/Locale.js";
// import CacheHelper from '@/helper/CacheHelper';
// import ConfigManager from "@/config/ConfigManager.js";
import { AccountModel } from '@/core/Account/model/AccountModel.js'
import Util from '@/helper/Utility.js'

export default {
    name: "Default",
    data: function () {
        return {
            params: {}
        }
    },
    created: function() {
        this.flowLogin()
    },
    methods: {
        flowLogin: function () {

            let lang = this.$route.query.Lang;
            let data1 = this.$route.query.Data1;
            let data2 = this.$route.query.Data2;
            let open_reward = this.$route.query.open_reward;

            if (!Util.isEmptyStr(open_reward)) {
                open_reward = atob(open_reward)
            }

            var params = {
                // lang: lang,
                uuid: data1,
                info: data2,
                os: "web",
                platform: "web",
            }

            this.params = params;

            BzbsAuth.apiLoginDevice(params).subscribe({
                next: (account) => {
                    console.log(account);
                    account.saveCache(account)
                    this.onSuccessLogin(lang, open_reward)
                    // console.log("login", account);
                    // let cache = new CacheHelper(ConfigManager.getCacheType());
                    // cache.setCache('BzbsUser', account);
                    // account.saveCache();


                },
                error: (err) => {
                    let errorInfo = {
                        url: window.location.href,
                        params: this.params,
                        error: err,
                    }
                    let json = encodeURIComponent(JSON.stringify(errorInfo))
                    this.$router.replace('/error/'+ err.id +"/" + err.code + "?message=" + json);
                }
            });
        },
        onSuccessLogin: async function (lang, open_reward) {
            await this.updateLocale(lang);
            if (open_reward) {
                window.location.replace("/" + open_reward);
            } else {
                window.location.replace("/");
            }
        },
        updateLocale: function (lang) {
            return new Promise((resolve) => {
                var locale = "1033";
                if (lang == "th-TH")
                {
                    locale = "1054";
                }

                BzbsProfile.changeLocale(locale).subscribe({
                    next: (data) => {
                        this.updateToken(data.data, locale);

                        Locale.setLocale(locale);
                        resolve();
                    },
                    error: (err) => {
                        let errorInfo = {
                            url: window.location.href,
                            params: this.params,
                            error: err,
                        }
                        let json = encodeURIComponent(JSON.stringify(errorInfo))
                        this.$router.replace('/error/'+err.id+"/"+err.code+"?message=" + json);
                    }
                });
            });
        },
        updateToken: function (token, locale) {
            let account = new AccountModel()
            account.loadCache()
            account.token = token;
            account.locale = locale;
            account.saveCache()
            // let cache = new CacheHelper(ConfigManager.getCacheType());
            // var user = cache.getCache('BzbsUser');
            // user.token = token
            // cache.setCache('BzbsUser', user);
        }
    }
}
</script>
<style lang="scss" scoped>

</style>
